import { IconsContainer } from '../../../../components/stories/organisms/top-navigation/styled-components'

const UtilityIcons = ({ children, ...props }) => {
  return <IconsContainer {...props}>{children}</IconsContainer>
}

export default UtilityIcons
